<template>
  <div class="navbar">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      :class="{'hamburger-close-slide': isCollapse }"
      @toggleClick="toggleSideBar"
    />

    <div class="right-menu" style="display: flex;align-items: center;">
      <time-zone-select style="height: 60px;line-height: 60px;margin-right: 32px;" class="right-menu-item hover-effect lang-select" />
      <DownLoadManage style="margin-right: 32px;" />
      <div style="height: 60px;line-height: 60px">

        <country-select class="right-menu-item hover-effect lang-select" style="margin-right: 32px;" />
        <lang-select class="right-menu-item hover-effect lang-select" style="margin-right: 32px;" />
        <message-manage v-if="$store.getters.isEz || $store.getters.isAruxpay" class="right-menu-item hover-effect lang-select" style="margin-right: 32px;" />
        <div class="username">
          <span><strong>{{ name }}</strong></span>
        </div>

        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASmSURBVHgBzVltTFtVGH7PubctUIowTBnlwyGx3RAYDnVZUNQsGv2B20xqssTEGM1i3A/N4scvg8v+mEz3w0QT3Q9/akLm2HTJJDIYsWhIGtmcFUjq+NAiIKj9oPTe3nt23m5tGOvH7YG0e/703nvOaZ++73ve87zvJSAIV9fzNguTSk0lzEZ0UkqAyZSAhGM6A02SSUzVmQIqXQ3r8fCk53wIBEDymex2u6U/gpqdxvSaJBmjoBpTGCWh4KIp4PP1KUbXGSKIxGbDWi2s6TWwBSAMlo0SzUmw/ZlDdovCHPlaLBfQopqJBMYG+5ezzcv6o3ufe6HexMkRAhS2GNzdErdkpcPpkgP+yWCmeWktiC6dWVGbiQ42KAA41dWGKnmqr69P2ziW1jKzK4qrUOQQTGNlaJB0Y3e4GN0KKlRCgcHdbUnn7tsIPrr/YDVRWT0UCTyfWqudu7QF/0Qk+Szl4ha326ypzAFFBmYM3APJ+xTBiiXVIUvEDEUGprPp/5WUoRK7GK1n+0dtA0G8/87Rzu7H9h0ps5Y6JUptoVDEO/Lj2BcnTn7iBUE03msax12dMGWz3dnAqZaBAD47dbznicf3fWSxmHkyJxZ8htfOB5p69rS1zl8YGJoCASwHQZ+f/T2ccDE/1IVSyqGeZx2721uPZRrv6Gg59tDuB4W+m0o3j1WKqkQ09p7e37UHXZrxR/jYqy+/+CQIAGOxi3Oj5VQuB0FUVVTk3PXVlZW1IIgQl3MUNF0o9hD/BoOBXHOWV4LzIAjUmtQki6eW019+fVnX9YxCVNP00OBlj/BONsdZGdUos4AgfrnyW2j86sTHmcav/Oo7dfbbizmtnAlxrnikhqaddbAJXPj+0lStvcZbu93uwPSCVotEVq/9cMlz/L3eD4dhE0CZR/Y+dbAT7mLIWOCIqmU8QZqadzjt26qcVqvVRW+lHEVRA5oWDwUWl7zX/dNTJ05+KhSHyI10dh9oyycPYuJ9980jhxsb6w9ny4HrocTjgavXfKcHh37y5hOTKGRliJNVbj9DBPHkeOvoK59bzOa8cptZlh0Pd7T3tre2ILnXjZLEspWqQAzXq2+89lJvvuQ2EsXvMLyA19TURrSo0fk2m3XTG8rKFY/RuSW84KceXvFjMEKBQA3GrcRIDLkl1Iyu0QUji6LRNSHptB6KEjcUfzqwMH4mCN6/XVo0suhM/8UPYjFF+GzFP/jVme/eNjIXOw/4maqLu7sPNMQkYoe7ANga+Xm4fxqvUzVJTY05UMhYzASMvaT1EvfJC5/Px3Y4dulMhnugiNAl+HN87Jtw8v62I25ubiLS3OiS+dlnhSLAorHF0eFzf69/dscZPDMzGaxr3mnDSh8KCDzWPEP9/o3P0/Zm7ttm8uMCKBCYCiFsHqUby9ofLMTORreOjJybyzSeVWbdcrei8x40l2QybCEYEC5T9MDo6PmsiTunDvzr+kS08pG2/0oiuixa3G8EWq3ObvIPDJzNKVTyaqJjiwR7OHEg5bw9mtcmQouZFG3J4bAspGtUbgnB9cCieg1ral62YmXI85cZX0UkyWDS5339KMo5VEwewdcQNwBzMNafo6WRXAAAAABJRU5ErkJggg==" class="user-avatar">
            <i class="el-icon-caret-bottom icon-arrow-down" />
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <el-dropdown-item @click.native="gotoAccountSetting">
              <span class="nav-settings-item">{{ $t('menu.account_settings') }}</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="logout">
              <span class="nav-settings-item" style="color: #FF332E"> {{ $t('components.login_out') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'
import LangSelect from './components/LangSelect'
import CountrySelect from './components/CountrySelect'
import DownLoadManage from './components/DownLoadManage'
import TimeZoneSelect from './components/TimeZoneSelect'
import MessageManage from './components/MessageManage/index.vue'

import Logo from './Sidebar/Logo'

export default {
  components: {
    Hamburger,
    LangSelect,
    Logo,
    CountrySelect,
    DownLoadManage,
    TimeZoneSelect,
    MessageManage
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'mainUserName'
    ]),
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    gotoAccountSetting() {
      this.$router.push('/systemManage/settings')
    }
  }
}
</script>

<style lang="scss" scoped>
.user-dropdown{
  padding: 12px;
}
.nav-settings-item{
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 24px;
}
.line{
display: inline-block;
  position: relative;
  top: -14px;
  margin: 0 32px;
  width: 1px;
  height: 26px;
  background: #B5BCC9;
}
.line-flex{
  display: inline-block;
  margin: 0 32px;
}
.icon-arrow-down{
  display: inline-block;
  margin-left: 12px;
  font-size: 12px;
  font-weight: bold;
}
.navbar {
  padding-right: 28px;
  height: 56px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {

    line-height: 60px;
    height: 100%;
    /*float: left;*/
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
  .right-menu {
    float: right;
    height: 100%;
    display: flex;
    align-items: center;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding-left: 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.lang-select{
        padding-top: 3px;
      }

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
    .avatar-wrapper {
      display: flex;
      align-items: center;
      height: 60px;
      .user-avatar {
        width: 32px;
      }
    }
    .username{
      display: inline-block;
      margin: 0 20px 0 16px;
      vertical-align: text-bottom;
      font-size: 14px;
      font-weight: 500;  font-family: 'Inter-Medium';
      color: #364250;
      min-width: 50px;
    }
  }
}
@media screen and (max-width: 376px) {
  .navbar {
     .right-menu {
      //  width: 130px;
       .username{
         margin: 0;
         margin-left: 5px;
       }
      }

  }
}
@media screen and (max-width: 761px) {
 .line{
  display: none;
 }
}
</style>
